module.exports = __webpack_public_path__ + "static/media/twitter.83e1d99a.svg";